import { render, staticRenderFns } from "./template-edit-popup.vue?vue&type=template&id=b443aeec&scoped=true&"
import script from "./template-edit-popup.vue?vue&type=script&lang=ts&"
export * from "./template-edit-popup.vue?vue&type=script&lang=ts&"
import style0 from "./template-edit-popup.vue?vue&type=style&index=0&id=b443aeec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b443aeec",
  null
  
)

export default component.exports